/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Carousel from 'react-bootstrap/Carousel';

import ReactLoading from 'react-loading';
import history from '../../../config/history';
import {
  Breadcrumbs,
  Container,
  ProductDetailsContainer,
  ProductDetailsContainerLeft,
  ProductDetailsContainerRight
} from './styles';

import Header from '../../molecules/Header';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import ProductListItems from '../../molecules/ProductListItems';
import ProductListHeading from '../../atoms/productlistheading';
import { listProducts, getProduct } from '../../../database/repositories/ProductRepository';

import { addProductFromCart } from '../../../store/ducks/cart';
import { getUser } from '../../../database/repositories/UserRepository';
import { addFavorie, remFavorie } from '../../../database/repositories/FavoriteRepository';
import { firebaseAnalytics } from '../../../config/firebase';
import { normalizeMoney } from '../../../utils/util';
import Dialog from '../../atoms/Dialog';
import Share from '../../atoms/Share';

function ProductDetails() {
  const { prodId } = useParams();

  const userData = useSelector((state) => state.auth.user_data);
  const dispatch = useDispatch();

  const [productData, setProductData] = useState(null);
  const [prodList, setProdList] = useState([]);
  const [seller, setSeller] = useState(null);

  useEffect(() => {
    firebaseAnalytics.logEvent(`${prodId}_visited`);
    const getInfoProduct = async () => {
      const product = await getProduct(prodId);
      setProductData(product);
      listProducts({ category: product.department }).then(setProdList);
      getUser(product.seller).then(setSeller);
    };

    getInfoProduct();
  }, [prodId]);

  const onFavoriteButton = async () => {
    if (userData?.favs?.includes(prodId)) {
      await remFavorie(prodId);
    } else {
      await addFavorie(prodId);
    }
  };
  return (
    <Container>
      {useSelector((state) => state.auth.user_logged_in) < 1 ? <Redirect to="/entrar" /> : null}
      <Header />
      <div
        style={{
          backgroundColor: '#002666',
          height: 500,
          marginBottom: -500
        }}
      />
      <MainContent>
        <Breadcrumbs>
          <div className="breadcrumbs-start">
            Voltar para <a href="/">Busca</a>
          </div>
          <div className="breadcrumbs-main">
            {productData?.department} <i> {'>'} </i>
            {productData?.subcategory}
          </div>
        </Breadcrumbs>
        <ProductDetailsContainer>
          <ProductDetailsContainerLeft>
            <div className="product-details-container-left-top">
              {productData ? (
                productData.pictures.length === 1 ? (
                  <img
                    className="d-block w-100"
                    src={productData.pictures[0]}
                    alt=" Carregando..."
                  />
                ) : (
                  <Carousel>
                    {productData.pictures.map((imageURL) => (
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          src={imageURL || null}
                          alt=" Carregando..."
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                )
              ) : null}
            </div>
          </ProductDetailsContainerLeft>
          {!productData ? (
            <ReactLoading type="spinningBubbles" color="#002666" height={100} width={100} />
          ) : (
            <ProductDetailsContainerRight>
              <div className="product-name-title-container">
                <h1>{productData ? productData.name : null}</h1>
                <div className="publication-date-text">
                  Publicado em{' '}
                  {productData ? new Date(productData.addedDate).toLocaleDateString('pt-br') : null}{' '}
                  ás 06:07
                </div>
                <div className="product-code-text">Cód: {prodId}</div>
              </div>
              <div className="product-price-seller-container">
                <div className="product-detail-price">
                  <div className="product-detail-stats-vendor">
                    <i className="fas fa-circle" /> Anunciante online
                  </div>
                  <div className="product-detail-iten-price">
                    {productData ? normalizeMoney(productData.price) : null}
                  </div>
                  {productData?.deleted ? (
                    <button>Produto removido</button>
                  ) : (
                    <button
                      onClick={() => {
                        dispatch(addProductFromCart(productData));
                        setTimeout(() => history.push('/confirmacompra'), 250);
                      }}>
                      Comprar kakareco
                    </button>
                  )}
                </div>
                <div className="product-detail-seller">
                  <div className="product-detail-seller-header">Vendedor</div>
                  <div className="product-detail-seller-name">{seller && seller.name}</div>
                  <div className="product-detail-seller-since">
                    Kakarecando desde{' '}
                    {seller && new Date(seller.joinDate).toLocaleDateString('pt-br')}
                  </div>
                  <div className="product-detail-seller-see-all">
                    <a href="/">Ver todos os anuncios</a>
                  </div>
                  <div className="product-detail-seller-send-msg">
                    {/* <button className="product-detail-seller-send-msg">
                      <Dialog msg="Enviar Mensagem" title="Mensagem" />
                    </button> */}
                  </div>
                </div>
              </div>
              <div className="product-description-container">
                <h6>Descrição</h6>
                {productData ? productData.description : null}
              </div>
              <div className="details-product-seller-container">
                <div>
                  <h6>Marca</h6>
                  {productData ? productData.brand : null}
                </div>
                <div>
                  <h6>Condição</h6>
                  {productData ? productData.condition : null}
                </div>
                <div>
                  <h6>Localização</h6>
                  Bom Retiro - São Paulo/SP
                </div>
              </div>

              <div className="social-media-container">
                <button onClick={onFavoriteButton}>
                  {userData?.favs?.includes(prodId) ? (
                    <>
                      Já é Favorito <i className="fas fa-heart" />
                    </>
                  ) : (
                    <>
                      Favoritar <i className="far fa-heart" />
                    </>
                  )}
                </button>
                <Share />
                <Dialog msg="Enviar Denuncia" title="Denuncia" />
              </div>

              <div className="security-hints-container">
                <i className="fas fa-exclamation-triangle" />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    marginLeft: 10
                  }}>
                  <h6 style={{ margin: 0 }}>Dica de segurança!!</h6>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'flex-end',
                      fontSize: 18
                    }}>
                    <h5 style={{ margin: 0 }}>
                      Atenção: não faça pagamentos antes de verificar o vendedor.
                    </h5>
                  </div>
                </div>
              </div>
            </ProductDetailsContainerRight>
          )}
        </ProductDetailsContainer>
        <ProductListHeading
          title="Produtos relacionados"
          side_link_to="/"
          side_link_txt="Ver todos"
        />
        {prodList.length > 0 ? <ProductListItems items={prodList.slice(0, 4)} size="14pt" /> : null}
        {/* cookie && <Txt>{cookie.productsBrowseHistory}</Txt> */}
      </MainContent>
      <Footer />
    </Container>
  );
}

export default ProductDetails;
